<template>
  <div>
    <el-form :model="form">
      <el-form-item label prop="name" :error="errors.name">
        <el-input v-model="form.name" :placeholder="this.$store.getters['auth/getResource']('reg_name')"></el-input>
      </el-form-item>
      <el-form-item label prop="phone" :error="errors.phone">
        <el-input v-model="form.phone" :placeholder="this.$store.getters['auth/getResource']('reg_phone')"></el-input>
      </el-form-item>
      <el-form-item label prop="email" :error="errors.email">
        <el-input v-model="form.email" :placeholder="this.$store.getters['auth/getResource']('reg_email')"></el-input>
      </el-form-item>
      <el-form-item label prop="password" :error="errors.password">
        <el-input type="password" v-model="form.password" :placeholder="this.$store.getters['auth/getResource']('reg_pass')"></el-input>
      </el-form-item>
      <el-form-item label prop="password_confirmation">
        <el-input
          type="password"
          v-model="form.password_confirmation"
          :placeholder="this.$store.getters['auth/getResource']('reg_pass_again')"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-col :span="24">
          <el-button type="primary" :loading="$store.state.auth.loading" @click="register" v-html="this.$store.getters['auth/getResource']('reg_actionbtn')"></el-button>
        </el-col>
      </el-form-item>
      <el-col class="back-col">
        <a @click="$store.commit('auth/loadComponent', 'login')" v-html="this.$store.getters['auth/getResource']('reg_back')"></a>
      </el-col>
    </el-form>
  </div>
</template>
<script>
export default {
  methods: {
    register() {
      this.$store.dispatch('auth/register');
    }
  },
  computed: {
    errors() {
      return this.$store.state.auth.errors;
    },
    form: {
      get() {
        return this.$store.state.auth.form;
      },
      set(newValue) {
        this.$store.commit('auth/setForm', newValue);
      }
    },
  }
}
</script>
<style scoped>
.back-col {
  text-align: right;
  margin-bottom: 10px;
}
</style>
